import { Component, OnInit } from '@angular/core';
import { DoctorsService } from '../../shared/doctor-service/doctors.service';
import { FormControl, FormGroup } from '@angular/forms';
import { Router, NavigationExtras} from '@angular/router';
import { async } from '@angular/core/testing';
@Component({
  selector: 'app-find-doctor',
  templateUrl: './find-doctor.component.html',
  styleUrls: ['./find-doctor.component.css']
})
export class FindDoctorComponent implements OnInit {
  CityDoctor:any;
  SearchDoctor:any;
  city:any;
  path = 'https://dev.api.doqmatokens.com/'
  count = 16 ;
  limitofFilter = 50 ;
  isLoading = false;
  isFind = false;
  name=new FormControl('');
  cityForm:any=FormGroup;
  findDoctorForm:any=FormGroup;
  navigationExtras:any;
  page:number=1;
  pages:any;
  docarry:any;
  pageOfFind:number=1;
  pagesOfFind:any;
  constructor(private doctorService : DoctorsService , private router:Router) { }

  ngOnInit(): void {
    if(localStorage.getItem('city')){
      this.city = localStorage.getItem('city');
    }else{

      this.city ="najibabad"
    }
    this.getAlldoctors();
  console.log("this is city ",this.CityDoctor);
  this.cityForm = new FormGroup({
    name: new FormControl(''),
  });
  this.findDoctorForm = new FormGroup({
    doctor: new FormControl(''),
  });

}
getAlldoctors(){
  console.log("this is page",this.page);
  
    this.doctorService.getCityDoctor(this.city,this.count,this.page).subscribe(async(data:any)=>{
      this.pages = data.data.pages;
     
      if(this.page > 1 && this.page <= this.pages){
        let myarry = await this.docarry.concat(data.data.docs);
        this.docarry = await myarry.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.doctorId.name === value.doctorId.name 
        ))
      )
      console.log("THIS IS FILTERED",this.docarry);
      }else{
        this.CityDoctor = data.data;
        let myarry = await data.data.docs;
        this.docarry = await myarry.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.doctorId.name === value.doctorId.name 
        ))
      )
      console.log("THIS IS FILTERED",this.docarry);
      
      }
      
      // console.log("this is city doctor data",this.path);
      console.log("this is doctor",data);
      
  });
}
onSubmit(data){
  this.city = data.name;
  this.count = 16;
  this.doctorService.getCityDoctor(data.name,this.count,this.page).subscribe((item:any)=>{
    console.log("success" , data.name);
    console.log("this is data of doctors", item);
    this.CityDoctor = item.data;
    // if(this.CityDoctor.pages < 0){
    //   document.getElementById("dcount").style.display = "none";
    //   document.getElementById("incount").style.display = "none";
    // }else{
    //   document.getElementById("dcount").style.display = "block";
    //   document.getElementById("incount").style.display = "block";
    // }
    // this.getAlldoctors();
  })
}
incount(){
  if(this.page <= this.pages){
    this.page = this.page + 1 ; 
  }
// if(this.count > this.CityDoctor.pages - 1){
//   document.getElementById("incount").style.display = "none";
//   this.getAlldoctors();
// }{
//   this.getAlldoctors();
//   document.getElementById("dcount").style.display = "block";
// } 
this.getAlldoctors();
}
incount1(){
  if(this.pageOfFind < this.pagesOfFind){
    this.pageOfFind = this.pageOfFind + 1;
  }
  // this.filterDoctor();
  this.isFind = true ;
  this.isLoading = true;
this.doctorService.doctorFilter(this.findDoctorForm.value.doctor , this.count,this.pageOfFind).subscribe((data:any)=>{
  console.log("this is filter data", data);
  this.isLoading=false;
  // this.getAlldoctors();
  this.pagesOfFind = data.data.pages;
  this.CityDoctor = data.data;
  // if(this.pageOfFind <= this.pagesOfFind && this.pageOfFind != 1){
    this.docarry = this.docarry.concat(data.data.docs);
  // }else{
  //   this.docarry = data.data.docs;
  // }
  // document.getElementById("closesearchDoctor").style.display = "block";
  // document.getElementById("viewmore").style.display="none";
  // document.getElementById("viewmore1").style.display="block";
});
  }

filterDoctor(keyword:any):void{
  this.isFind = true;
  console.log(keyword,"this is keyword");
  
  if(keyword == ""){
    this.isLoading = false;
    this.isFind = false;
    this.findDoctorForm = new FormGroup({
      doctor: new FormControl(''),
    });
    this.count = 16;
    this.getAlldoctors();
    // console.warn("error");
    
    // document.getElementById("viewmore").style.display="none"
  }else{
  this.isFind = true ;
    this.isLoading = true;
  this.doctorService.doctorFilter(keyword , this.count,1).subscribe((data:any)=>{
    console.log("this is filter data", data);
    this.isLoading=false;
    this.pageOfFind = 1;
    // this.getAlldoctors();
    this.pagesOfFind = data.data.pages;
    this.CityDoctor = data.data;
    // if(this.pageOfFind <= this.pagesOfFind && this.pageOfFind != 1){
    //   this.docarry = this.docarry.concat(data.data.docs);
    // }else{
      this.docarry = data.data.docs;
    // }
    // document.getElementById("closesearchDoctor").style.display = "block";
    // document.getElementById("viewmore").style.display="none";
    // document.getElementById("viewmore1").style.display="block";
  });
  }
}
closeFind(){
  this.count = 16;
  this.page=1;
  this.getAlldoctors();
  this.findDoctorForm = new FormGroup({
    doctor: new FormControl(''),
  });
  this.isLoading = false;
  this.isFind = false;
  // document.getElementById("closesearchDoctor").style.display = "none";
  // document.getElementById("viewmore").style.display="block";
}
sendDoctor(_id){
this.navigationExtras= {
  state: {
    transd: _id,
  }
};
// this.router.navigate(['viewdoctor',_id]);
this.router.navigate(['download'])
}
}
